import { type ForwardedRef, forwardRef } from 'react';

import { DependentRelation } from '@/common/graphql';
import { DependentRelationLabels } from '@/common/types';
import { ObjectUtils } from '@/common/utils';

import type { ComboboxItemWithFormatted } from '../props';
import { SelectSingle, type SelectSingleProps } from '../SelectSingle';

const order = [
  DependentRelation.Spouse,
  DependentRelation.Child,
  DependentRelation.AdoptedChild,
  DependentRelation.Parent,
  DependentRelation.Sibling,
  DependentRelation.Other,
];

const data = ObjectUtils.arrayFromEnumValues<DependentRelation>(DependentRelation)
  .map(value => ({
    label: DependentRelationLabels[value],
    value,
  }))
  .sort((a, b) => order.indexOf(a.value) - order.indexOf(b.value));

interface DependentRelationSelectSingleProps
  extends Omit<SelectSingleProps<ComboboxItemWithFormatted<DependentRelation>>, 'searchable' | 'value'> {
  value: DependentRelation | null;
}

export const DependentRelationSelectSingle = forwardRef(
  (
    { placeholder = 'Select relation', ...rest }: DependentRelationSelectSingleProps,
    ref: ForwardedRef<HTMLDivElement>,
  ) => (
    <SelectSingle
      ref={ref}
      {...rest}
      data={data}
      loading={false}
      maxItemVisible={data.length}
      placeholder={placeholder}
    />
  ),
);
